import {
  CustomerAddressError,
  makeCustomerRequest
} from '@api/graphqlShopify/makeCustomerRequest'
import { Address } from '@components/account/types'
import { customerAddressUpdateMutation } from '@api/graphqlShopify/mutations'
import { parse } from '@helpers/shopify'
import { getErrorMessage } from '@api/graphqlShopify'
import trackError from '@helpers/trackError'
import {
  UpdateAddressData,
  UpdateAddressSchema
} from '../drawer/shared/AddressFormFields'

export async function addressUpdate(address: UpdateAddressData, token: string) {
  try {
    if (!address?.id) {
      throw Error('No address id')
    }

    const result = UpdateAddressSchema.safeParse(address)

    if (!result.success) {
      throw result.error
    }

    const { id, defaultAddress, ...filteredAddress } = address

    const { data } = await makeCustomerRequest<{
      customerAddressUpdate: {
        userErrors: CustomerAddressError[]
        customerAddress: Address
      }
      addressId: string
    }>(
      customerAddressUpdateMutation,
      {
        addressId: id,
        address: filteredAddress,
        defaultAddress
      },
      token
    )

    const { customerAddress, userErrors } = parse(
      data.customerAddressUpdate
    ) as {
      customerAddress: Address
      userErrors: CustomerAddressError[]
    }

    if (userErrors?.length) {
      throw userErrors
    }

    return customerAddress
  } catch (e) {
    const error = e as Error
    const errorMessage = getErrorMessage(error)
    trackError(new Error(`addressUpdate failed - ${errorMessage}`), {
      addressId: address.id,
      address: JSON.stringify(address),
      error,
      section: 'Account Page'
    })
    throw error
  }
}
